import { TooltipProps } from '@huner2/react-tooltip';

export const tooltipStyle: TooltipProps = {
  effect: 'solid',
  border: true,
  borderColor: '#ccc',
  className: 'tooltip',
};
